{
  "styles": {
    "models": {
      "resetHeight": "Réinitialiser la hauteur",
      "resetLength": "Réinitialiser la longueur",
      "resetWidth": "Réinitialiser la largeur",
      "attributeModel": "Modifiez votre modèle 3D en modifiant le modèle et les dimensions",
      "attributeDimensions": "Modifiez votre modèle 3D en modifiant les dimensions",
      "determineModel": "Déterminer le modèle par",
      "determineDimensions": "Déterminez la longueur, la largeur et la hauteur en"
    }
  },
  "exports": {
    "legendPosition": "Position de la légende",
    "top": "Haut",
    "bottom": "En bas",
    "left": "Gauche",
    "right": "Droite",
    "layers": "Couches",
    "all": "Tous",
    "custom": "Personnalisé",
    "selectLayers": "Sélectionnez les couches à exporter",
    "selected": "sélectionné",
    "hidden": "(Caché)",
    "none": "Aucune"
  },
  "get_map_errors": {
    "default": "Quelque chose s'est mal passé",
    "not_found": "Plan introuvable",
    "click_here_to_browser_maps": "Cliquez ici pour consulter les forfaits"
  },
  "add_list_item_attribute": {
    "title": "Ajouter une colonne",
    "subtitle": "Modifiez cet attribut selon vos besoins en utilisant les champs ci-dessous",
    "column_name": "Nom de colonne",
    "column_type": "Type de colonne",
    "type": "Type de propriété"
  },
  "list_item_properties": {
    "additional_properties": "Propriétés supplémentaires"
  },
  "contextMenu": {
    "import": "Importer",
    "export": "Exporter",
    "copy_layer": "Copier la couche {{ pluralise }}",
    "copy_group": "Copier le groupe {{ pluralise }}",
    "copy_layer_and_group": "Copiez la couche {{ pluraliseLayers }} et le groupe {{ pluraliseGroups }}",
    "delete": "Supprimer",
    "delete_layers_title": "Supprimer des couches",
    "delete_layers_description": "Une ou plusieurs des couches que vous essayez de supprimer sont liées à une autre carte. Ils sont en train d'être supprimés de cette carte et vous pouvez les relier à tout moment."
  },
  "copyOrUnlinkLayers": {
    "copy": "Copier",
    "unlink": "Dissocier",
    "copying_layers": "Copier des couches",
    "unlink_layer": "Dissocier une couche",
    "linked_layers": "Couches liées",
    "original_plan": "Plan original",
    "helpbase_blurb": {
      "click": "Cliquez ici",
      "link": "Pour démarrer - Base de connaissances (iventis.com)",
      "further_info": "pour de plus amples informations."
    },
    "copy_blurb": {
      "are_you_sure": "Êtes-vous sûr de vouloir copier",
      "this": "ce",
      "these": "celles-ci",
      "layer": "couche {{ pluralise }}",
      "group": "groupe {{ pluralise }}",
      "layers_and_groups": "couches et groupes"
    },
    "unlink_info": {
      "links_to": "Cette couche est liée à",
      "changes_not_reflected": "En dissociant le plan d'origine, vous créez une copie. Les modifications apportées à la couche d'origine ne seront plus prises en compte dans votre plan."
    },
    "unlink_blurb": "Vous copiez des couches liées à différentes cartes. En dissociant le plan d'origine, vous créez une copie. Les modifications apportées à la couche d'origine ne seront plus prises en compte dans votre plan.",
    "copy_with_map_objects": "Copier la couche {{ pluralise }} avec les objets de la carte"
  },
  "shareMap": {
    "title": "Forfait de partage",
    "share_with_team": "Partagez avec l'équipe",
    "share_with_team_details": "Partagez le plan avec les membres de l'équipe en le déplaçant dans « Espace de travail d'équipe »",
    "shared_library": {
      "title": "Partager un fichier avec l'équipe",
      "footer": "Les membres de l'équipe peuvent consulter le fichier en lecture seule"
    },
    "shared_link": {
      "title": "Lien de partage"
    },
    "share_link": "Générer un lien",
    "share_link_details": "Créez un lien temporaire en lecture seule pour partager ce plan avec les utilisateurs qui n'ont pas accès à Iventis",
    "share_link_generated": "Ce lien expirera dans {{ numberOfDays }} jours. Vous pouvez générer un nouveau lien à tout moment."
  },
  "defaultAttribute": {
    "add": "Ajouter une valeur par défaut pour l'attribut",
    "default_field_type": "Valeur par défaut {{ dataFieldType }}",
    "tickbox": {
      "label": "État de la case à cocher par défaut",
      "on": "SUR",
      "off": "OFF"
    }
  },
  "fileUpload": {
    "import_title": "Importer des données sur une carte",
    "drop_file": "Déposer le fichier à télécharger",
    "supported_extensions": "Extensions prises en charge",
    "contact_support": "Contactez le support pour les fichiers plus volumineux et les autres extensions",
    "choose_file": "Choisissez un fichier",
    "max_file_size": "Taille de fichier maximale {{ maxFileSize }} Mo"
  }
}